<section class="dynamic-collapse">
	<section class="dynamic-collapse-header">
		<div class="data">
			<!-- <img class="first-bar" src="../../assets/img/first-bar.svg" alt=""> -->
			<svg width="13" height="51" viewBox="0 0 13 51" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M0.478516 6.88888V50.3148H12.8859V6.88889C12.8859 3.46267 10.1084 0.685181 6.68222 0.685181C3.25601 0.685181 0.478516 3.46267 0.478516 6.88888Z"
					class="svg-sign-first-bar" />
			</svg>
			<svg width="14" height="38" viewBox="0 0 14 38" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M0.740723 6.2963V37.3148H13.1481V6.29629C13.1481 2.87008 10.3706 0.0925903 6.94443 0.0925903C3.51822 0.0925903 0.740723 2.87009 0.740723 6.2963Z"
					class="svg-sign-scd-bar" />
			</svg>
			<img class="bottom-bar" src="../../assets/img/bottom-bar.svg" alt="">
		</div>
		<div class="data-info">
			<h3>Net Income</h3>
			<h2><span>{{income - expense | currency:'GBP':'symbol-narrow':'1.0'}}</span></h2>
		</div>
	</section>
	<section class="dynamic-collapse-main">
		<div class="dynamic-collapse-content">
			<li class="actual-section" (click)="setFilter('income')" [ngClass]="{chosenTabClass:chosentab==='income'}">
				<div class="summaries-details">
					<span class="item-name first-category">Annual Income</span>
					<!-- <span class="total-count">{{income | currency:'GBP':'symbol-narrow':'1.0'}}</span> -->
					<span *ngIf="income>=0" class="total-count">{{income | currency:'GBP':'symbol-narrow':'1.0'}}</span>
					<span *ngIf="income<0" style="color:red" class="total-count">({{income * -1 |
						currency:'GBP':'symbol-narrow':'1.0'}})</span>
				</div>
				<div class="triangle"></div>
			</li>
			<li class="actual-section" (click)="setFilter('expenses')"
				[ngClass]="{chosenTabClass:chosentab==='expenses'}">
				<div class="summaries-details">
					<span class="item-name scd-category">Annual Expense</span>
					<!-- <span class="total-count">{{expense | currency:'GBP':'symbol-narrow':'1.0'}}</span> -->
					<span *ngIf="expense>=0" class="total-count">{{expense |
						currency:'GBP':'symbol-narrow':'1.0'}}</span>
					<span *ngIf="expense<0" style="color:red" class="total-count">({{expense * -1 |
						currency:'GBP':'symbol-narrow':'1.0'}})</span>
				</div>
				<div class="triangle"></div>
			</li>
		</div>
	</section>
</section>